<div class="modal-select-protocol-type">
    <div class="modal-header">
        <h2>{{ 'protocol_type_selection.title' | translate }}</h2>
        <button (click)="onCancel()" aria-label="Cerrar" class="btn-close">
            <img src="assets/icons/close-modal.svg" alt="Cerrar" />
        </button>
    </div>

    <div class="modal-subtitle">
        {{ 'protocol_type_selection.subtitle' | translate }}
    </div>

    <div class="protocol-types-container">
        <button class="protocol-type-card complete" (click)="onSelectComplete()">
            <div class="card-icon">
                <img src="assets/icons/clipboard-check.svg" alt="" />
            </div>
            <div class="card-content">
                <h3 class="card-title">{{ 'protocol_type_selection.complete.title' | translate }}</h3>
                <p class="card-description">{{ 'protocol_type_selection.complete.description' | translate }}</p>
                <ul class="card-features">
                    <li>
                        <img src="assets/icons/check-circle.svg" alt="" />
                        {{ 'protocol_type_selection.complete.feature_photos' | translate }}
                    </li>
                    <li>
                        <img src="assets/icons/check-circle.svg" alt="" />
                        {{ 'protocol_type_selection.complete.feature_documents' | translate }}
                    </li>
                    <li>
                        <img src="assets/icons/check-circle.svg" alt="" />
                        {{ 'protocol_type_selection.complete.feature_signatures' | translate }}
                    </li>
                    <li>
                        <img src="assets/icons/check-circle.svg" alt="" />
                        {{ 'protocol_type_selection.complete.feature_details' | translate }}
                    </li>
                </ul>
                <div class="card-badge">{{ 'protocol_type_selection.complete.badge' | translate }}</div>
            </div>
        </button>

        <button class="protocol-type-card quick" (click)="onSelectQuick()">
            <div class="card-icon">
                <img src="assets/icons/lightning-bolt-black.svg" alt="" />
            </div>
            <div class="card-content">
                <h3 class="card-title">{{ 'protocol_type_selection.quick.title' | translate }}</h3>
                <p class="card-description">{{ 'protocol_type_selection.quick.description' | translate }}</p>
                <ul class="card-features">
                    <li>
                        <img src="assets/icons/check-circle.svg" alt="" />
                        {{ 'protocol_type_selection.quick.feature_basic' | translate }}
                    </li>
                    <li>
                        <img src="assets/icons/check-circle.svg" alt="" />
                        {{ 'protocol_type_selection.quick.feature_fast' | translate }}
                    </li>
                    <li>
                        <img src="assets/icons/check-circle.svg" alt="" />
                        {{ 'protocol_type_selection.quick.feature_simple' | translate }}
                    </li>
                </ul>
                <div class="card-badge quick">{{ 'protocol_type_selection.quick.badge' | translate }}</div>
            </div>
        </button>
    </div>
</div>